import React, { useContext } from 'react';

import cx from 'classnames';

import EditableText from 'components/shared/EditableText';
import LandingPageContext from 'components/shared/LandingPage/contexts/LandingPageContext';

import s from './index.module.css';

function CoverPage(props) {
  const { data, onUpdate } = props;
  const { readOnly } = useContext(LandingPageContext);
  const titleValue = data?.data?.title || '';
  const subtitleValue = data?.data?.subtitle || '';

  const handleChange = (enteredValue, type) => {
    const obj = { ...data, data: { ...data?.data, [type]: enteredValue } };
    onUpdate(obj);
  };

  return (
    <div className={cx(s.wrapper, 'custom-coverpage-wrapper')}>
      {(!readOnly || titleValue) && (
        <div className={cx(s.title, 'custom-coverpage-title')}>
          <EditableText
            text={titleValue}
            onChange={(value) => handleChange(value, 'title')}
            placeholder="Title"
            textAlignment="center"
            isReadonly={readOnly}
            isLineBreak
          />
        </div>
      )}
      {(!readOnly || subtitleValue) && (
        <div className={cx(s.subtitle, 'custom-coverpage-subtitle')}>
          <EditableText
            text={subtitleValue}
            onChange={(value) => handleChange(value, 'subtitle')}
            placeholder="Subtitle"
            textAlignment="center"
            isReadonly={readOnly}
            isLineBreak
          />
        </div>
      )}
    </div>
  );
}

export default CoverPage;
